var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marketplace-state",class:{
    'marketplace-state-white': _vm.white
  },on:{"click":function($event){return _vm.toggle()}}},[(_vm.isInFavorites)?_c('bookmark-filled-icon',{staticClass:"icon icon-white"}):_c('bookmark-icon',{staticClass:"icon icon-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }